export const fontWeights = {
  regular: 450,
  medium: 550,
  semiBold: 650,
  bold: 650,
};
